module.exports = __webpack_public_path__ + "img/ads_side.16c55519.jpg";